import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import Layout from "./components/Layout";
import Dashboard from "./pages/Dashboard";
import BankAccounts from "./pages/BankAccounts";
import Invoices from "./pages/Invoices";
import Payables from "./pages/Payables";
import CreditCards from "./pages/CreditCards";
import FixedExpenses from "./pages/FixedExpenses";
import VariableExpenses from "./pages/VariableExpenses";
import EstimatedInflows from "./pages/EstimatedInflows";
import Analytics from "./pages/Analytics";
import DataUpload from "./pages/DataUpload";
import UserManagement from "./pages/UserManagement";
import Alerts from "./pages/Alerts";
import Projects from "./pages/Projects";
import Login from "./pages/Login";

function ProtectedRoute({ children }) {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="flex flex-col items-center gap-3">
          <div className="animate-spin h-8 w-8 border-4 border-brand-orange border-t-transparent rounded-full" />
          <p className="text-sm text-slate-500">Loading...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return children;
}

function PublicRoute({ children }) {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="animate-spin h-8 w-8 border-4 border-brand-orange border-t-transparent rounded-full" />
      </div>
    );
  }

  if (isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  return children;
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Toaster position="top-right" richColors />
        <Routes>
          <Route path="/login" element={<PublicRoute><Login /></PublicRoute>} />
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <Layout />
              </ProtectedRoute>
            }
          >
            <Route index element={<Dashboard />} />
            <Route path="bank-accounts" element={<BankAccounts />} />
            <Route path="invoices" element={<Invoices />} />
            <Route path="payables" element={<Payables />} />
            <Route path="credit-cards" element={<CreditCards />} />
            <Route path="fixed-expenses" element={<FixedExpenses />} />
            <Route path="variable-expenses" element={<VariableExpenses />} />
            <Route path="estimated-inflows" element={<EstimatedInflows />} />
            <Route path="analytics" element={<Analytics />} />
            <Route path="upload" element={<DataUpload />} />
            <Route path="alerts" element={<Alerts />} />
            <Route path="projects" element={<Projects />} />
            <Route path="users" element={<UserManagement />} />
          </Route>
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
